import React from 'react';
import { Grid } from '@mui/material';
import PlayerMessage from './PlayerMessage';
import LiveViewPlayer from './LiveViewPlayer';
import {
    useLiveCameras,
    useLiveCamerasStatus,
} from '../../../features/LiveView/state/index.hooks';
import LoadingSpinner from '../../../components/loadingSpinner/LoadingSpinner';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    monitoredId: string;
}

const LiveViewPlayers = ({ monitoredId }: IOwnProps) => {
    const liveViews = useLiveCameras();
    const liveViewsStatus = useLiveCamerasStatus();
    const classes = useStyles();

    const isLoading =
        !liveViews || !liveViews.cameras || liveViewsStatus === 'loading';
    if (isLoading) {
        return (
            <div className={classes.spinner}>
                <LoadingSpinner />
            </div>
        );
    }

    const cameras = liveViews.cameras.map((camera) => ({
        paramName: camera.paramName,
        videoSrc: `/rest/api/monitored/movies/live/${monitoredId}/${camera.paramName}`,
    }));

    return (
        <Grid
            container={true}
            spacing={2}
            justifyContent="center"
            alignItems="start"
        >
            {cameras.length > 0 ? (
                cameras.map((camera) => {
                    return (
                        <LiveViewPlayer
                            cameraName={camera.paramName}
                            smallerSize={cameras.length > 2}
                            videoSource={camera.videoSrc}
                            key={camera.paramName}
                        />
                    );
                })
            ) : (
                <PlayerMessage message="There are no cameras on device" />
            )}
        </Grid>
    );
};

export default LiveViewPlayers;
